// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_53-0";